import React from 'react';
import PropTypes from 'prop-types';
import _has from 'lodash/has';
import { ruleType } from 'types';
import RuleItem from '../RuleItem';
import RuleGroupItem from '../RuleGroupItem';

const RuleTemplate = ({
  searchTerm,
  model,
  fullGroups,
  isPreSelected,
  isSelected,
  isArchived,
  count,
  index,
  reorderItem,
  reorderGroupItem,
  matchedRulesMap,
  getRuleMatchedRows,
  toggleItemStatus,
  onOpenDuplicateModal,
  selectGroupItem,
  selectedGroupItem,

  onOpenAddRuleModal,
  onOpenDeleteModal,
  moveRuleToGroup,
  partialUpdateGroup,
  partialUpdateRule,
}) => {
  if (_has(model, 'rules')) {
    return (
      <RuleGroupItem
        count={count}
        fullGroups={fullGroups}
        getRuleMatchedRows={getRuleMatchedRows}
        isArchived={isArchived}
        isGrouped={false}
        isPreSelected={isPreSelected}
        isSelected={isSelected}
        matchedRulesMap={matchedRulesMap}
        model={model}
        moveRuleToGroup={moveRuleToGroup}
        partialUpdateItem={partialUpdateGroup}
        partialUpdateRule={partialUpdateRule}
        reorderGroupItem={reorderGroupItem}
        reorderItem={reorderItem}
        searchTerm={searchTerm}
        selectedGroupItem={selectedGroupItem}
        selectGroupItem={selectGroupItem}
        toggleItemStatus={toggleItemStatus}
        onOpenAddRuleModal={onOpenAddRuleModal}
        onOpenDeleteModal={onOpenDeleteModal}
        onOpenDuplicateModal={onOpenDuplicateModal}
      />
    );
  }

  return (
    <RuleItem
      count={count}
      fullGroups={fullGroups}
      getRuleMatchedRows={getRuleMatchedRows}
      index={index}
      isArchived={isArchived}
      isGrouped={false}
      isPreSelected={isPreSelected}
      isSelected={isSelected}
      matchedRulesMap={matchedRulesMap}
      model={model}
      moveRuleToGroup={moveRuleToGroup}
      partialUpdateItem={partialUpdateGroup}
      reorderItem={reorderItem}
      searchTerm={searchTerm}
      selectedGroupItem={selectedGroupItem}
      toggleItemStatus={toggleItemStatus}
      onOpenDuplicateModal={onOpenDuplicateModal}
    />
  );
};

RuleTemplate.propTypes = {
  count: PropTypes.number,
  fullGroups: PropTypes.arrayOf(ruleType),
  getRuleMatchedRows: PropTypes.func,
  index: PropTypes.number,
  isArchived: PropTypes.bool,
  isPreSelected: PropTypes.bool,
  isSelected: PropTypes.bool,
  matchedRulesMap: PropTypes.shape({}),
  model: ruleType,
  moveRuleToGroup: PropTypes.func,
  partialUpdateGroup: PropTypes.func,
  partialUpdateRule: PropTypes.func,
  reorderGroupItem: PropTypes.func,
  reorderItem: PropTypes.func,
  searchTerm: PropTypes.string,
  selectedGroupItem: ruleType,
  selectGroupItem: PropTypes.func,
  toggleItemStatus: PropTypes.func,
  onOpenAddRuleModal: PropTypes.func,
  onOpenDeleteModal: PropTypes.func,
  onOpenDuplicateModal: PropTypes.func,
};
export default RuleTemplate;
